<template>
  <el-dialog
      title="Xuất Excel theo ngày"
      :visible.sync="showExportExcelDateDialog"
      width="600px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      custom-class="sk-dialog"
  >
    <div class="sk-dialog-content">
      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon" style="background: linear-gradient(135deg, #34d399, #059669)">
            <i class="el-icon-download"></i>
          </div>
          <div>
            <p class="sk-panel-title">Xuất danh sách học sinh theo ngày</p>
            <p class="sk-panel-subtitle">Chọn ngày, lớp và trạng thái để xuất file Excel.</p>
          </div>
        </div>
        <el-form :model="formData" label-position="left" :rules="rules" ref="formData" label-width="120px">
          <el-form-item label="Chọn ngày" prop="date">
            <el-date-picker
                style="width: 100%"
                v-model="formData.date"
                type="date"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Chọn ngày">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Chọn lớp">
            <el-select v-model="formData.idClass" clearable placeholder="Chọn lớp" style="width: 100%">
              <el-option
                  v-for="item in classListCommon"
                  :key="item.id"
                  :label="item.className"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Trạng thái" prop="status">
            <el-select
                clearable
                style="width: 100%"
                v-model="formData.status"
                placeholder="Trạng thái"
            >
              <el-option
                  v-for="item in kidStatusList"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer sk-dialog-footer">
      <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialog()">
        <i class="el-icon-circle-close"/>
        <span>{{ $t("button.close") }}</span>
      </el-button>
      <el-button
          class="btn-save"
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm()"
      >
        <i class="el-icon-circle-check"/>
        <span>Xuất Excel</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {kidStatusList} from "@/constant/listCommon";
import {mapGetters} from "vuex";
import studentService from "@/services/StudentService";

export default {
  props: {
    showExportExcelDateDialog: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      kidStatusList,
      formData: {
        date: "",
        idClass: "",
        status: "",
      },
      styleCols1: [],
      styleCols2: [],
      loadingButton: false,
      rules: {
        date: [
          {required: true, message: 'Chọn thời gian', trigger: 'change'}
        ],

      }
    };
  },
  computed: {
    ...mapGetters('classStore', ['classListCommon'])
  },
  created() {
    this.$store.dispatch('classStore/fetchDataClassListCommon')
  },
  methods: {
    //reset when click x
    closeDialog() {
      this.formData.idClass = "";
      this.$refs["formData"].resetFields();
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false;
      }, 300);
    },
    submitForm() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          this.getStyleExcelStudent();
          studentService.exportExcelMonthForKids(this.formData.idClass, this.formData.date, this.formData.status).then((resp) =>{
            import("@/services/ExportExcel")
                .then((excel) => {
                  let dataList = resp.data.data;
                  let fileName = `QUAN_LY_HOC_SINH_${this.formData.date}`;
                  const tHeader = [
                    "STT",
                    "Tình trạng",
                    "Khối học",
                    "Lớp học",
                    "Tên nhóm",
                    "Họ và tên",
                    "Ngày sinh",
                    "Giới tính",
                    "Biệt danh",
                    "Địa chỉ hiện tại",
                    "Địa chỉ thường trú",
                    "Dân tộc",
                    "Số định danh",
                    "Người đại diện",
                    "Ngày nhập học",
                    "Ngày bảo lưu",
                    "Ngày nghỉ",
                    "Họ tên mẹ",
                    "Ngày sinh",
                    "Số điện thoại",
                    "Email",
                    "Nghề nghiệp",
                    "Họ tên bố",
                    "Ngày sinh",
                    "Số điện thoại",
                    "Email",
                    "Nghề nghiệp",
                    "Ghi chú",
                  ];
                  const filterVal = [
                    "pro1",
                    "pro2",
                    "pro3",
                    "pro4",
                    "pro5",
                    "pro6",
                    "pro7",
                    "pro8",
                    "pro9",
                    "pro10",
                    "pro11",
                    "pro12",
                    "pro13",
                    "pro14",
                    "pro15",
                    "pro16",
                    "pro17",
                    "pro18",
                    "pro19",
                    "pro20",
                    "pro21",
                    "pro22",
                    "pro23",
                    "pro24",
                    "pro25",
                    "pro26",
                    "pro27",
                    "pro28",
                  ];
                  let columnList = [
                    {col: 5},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 10},
                    {col: 20},
                    {col: 25},
                    {col: 25},
                    {col: 10},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 30},
                  ];
                  excel.export_json_to_excel({
                    header: tHeader,
                    data: dataList,
                    title: filterVal,
                    filename: fileName,
                    columnsWidth: columnList,
                    styleCols1: this.styleCols1,
                    styleCols2: this.styleCols2,
                  });
                })
                .finally(() => {
                  this.styleCols1 = [];
                  this.styleCols2 = [];
                });
          })
          console.log(this.formData);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //Style css Excel Student
    getStyleExcelStudent() {
      let font = this.$styleExcel.fontTitle();
      let alignment = this.$styleExcel.alignmentTitle();
      let border = this.$styleExcel.borderTitle();
      let styleCol1 = {
        name: "A5:P5",
        style: {
          fill: {fgColor: {rgb: "ffff00"}},
          font,
          alignment,
          border,
        },
      };
      let styleCol2 = {
        name: "Q5:U5",
        style: {
          fill: {fgColor: {rgb: "ffb2bd"}},
          font,
          alignment,
          border,
        },
      };
      let styleCol3 = {
        name: "V5:AB5",
        style: {
          fill: {fgColor: {rgb: "78f388"}},
          font,
          alignment,
          border,
        },
      };
      //style1
      let styleCol4 = {
        name: ["A1"],
        style: {
          font: {color: {rgb: "ff0000"}, bold: true, sz: "18"},
        },
      };
      let styleCol5 = {
        name: ["A2", "A3", "A4"],
        style: {
          font: {bold: true, sz: "11"},
        },
      };
      this.styleCols2.push(styleCol1);
      this.styleCols2.push(styleCol2);
      this.styleCols2.push(styleCol3);

      this.styleCols1.push(styleCol4);
      this.styleCols1.push(styleCol5);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
</style>
